import '../public/styles/globals.css';
import '../public/styles/skeleton.css';
import '../public/styles/animation.css';
import '../public/styles/app-ui.css';
import '../public/styles/app-components.css';
import '../public/styles/app-ui-coop-finance.css';
import '../public/styles/custom-app.css';

import { createApp, DirectiveBinding } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import money from 'v-money3'
import VueApexCharts from "vue3-apexcharts"
import SidebarLayout from './layouts/SidebarLayout.vue';
import NavbarLayout from './layouts/NavbarLayout.vue';
import CustomModal from './components/CustomModal.vue';
import CustomButton from './components/CustomButton.vue';
import CustomUploadInput from './components/CustomUploadInput.vue';
import CustomPagination from './components/CustomPagination.vue';
import CustomPhoneInput from './components/CustomPhoneInput.vue';
import CustomBlocFileInput from './components/CustomBlocFileInput.vue';
import { useLoadingStore } from './stores/loading.store';

const pinia = createPinia()
const app = createApp(App);

// Charger les variables d'environnement
const backendUrl = process.env.VUE_APP_API_URL || "https://backend.coop-finance-app.wixoon.dev";
const envName = process.env.VUE_APP_ENV || "prod";

// Debug: Afficher la configuration chargée
console.log('[Config] Backend URL:', backendUrl);
console.log('[Config] Environment:', envName);
console.log('[Config] VUE_APP_API_URL from env:', process.env.VUE_APP_API_URL);

// Ne pas ajouter /api si l'URL contient déjà /api ou si c'est déjà dans le backendUrl
// Laravel ajoute automatiquement /api pour les routes dans routes/api.php
let baseURL = backendUrl;
if (!baseURL.endsWith('/api') && !baseURL.endsWith('/api/')) {
  baseURL = `${backendUrl}/api`;
}

axios.defaults.baseURL = baseURL;
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;
axios.interceptors.request.use(
  (config) => {
    const loading = useLoadingStore();
    loading.start();
    const token = localStorage.getItem('LS_COOP_FINANCE_BO_ACCESS_TOKEN');
    if (token) { config.headers['Authorization'] = `Bearer ${token}`; }
    return config;
  },
  (error) => {
    const loading = useLoadingStore();
    loading.stop();
    return Promise.reject(error);
  }
);
axios.interceptors.response.use((response) => {
  const loading = useLoadingStore();
  loading.stop();
  return response
}, (error) => {
  const loading = useLoadingStore();
  loading.stop();
  const errorResponseData = {
    axioserrorcode: error.code,
    message: error.response?.data?.message ? error.response.data.message : 'Une erreur est survenue lors de la requete au serveur',
    stacktrace: error.response?.data?.stacktrace ? error.response.data.stacktrace : null,
    httpstatuscode: error.response?.data?.httpstatuscode ? error.response.data.httpstatuscode : null,
  };
  if (errorResponseData.httpstatuscode == 401) {
    const accessToken = localStorage.getItem('LS_COOP_FINANCE_BO_ACCESS_TOKEN');
    if (accessToken) {
      axios.post('/backoffice/auth/signout', {}, { headers: { Authorization: `Bearer ${accessToken}` } });
      localStorage.removeItem('LS_COOP_FINANCE_BO_ACCESS_TOKEN');
      localStorage.removeItem('LS_COOP_FINANCE_BO_AUTH_USER');
    }
    router.replace('/auth/login');
  }
  return Promise.reject(errorResponseData);
});
app.config.globalProperties.$axios = axios

app.directive('hasPermissions', {
  mounted: (el: any, binding: DirectiveBinding<any, string, string>) => {
    try {
      const authenticatedUserRaw = localStorage.getItem('LS_COOP_FINANCE_BO_AUTH_USER');
      const authenticatedUser = JSON.parse(authenticatedUserRaw!);
      const codesPermissions = authenticatedUser.codes_permissions as string[];
      const permissions = binding.value as string[];
      const hasPermission = permissions.reduce((previousVal, currentVal) => previousVal && codesPermissions.includes(currentVal), true);
      if (!hasPermission) {
        el.style.display = 'none';
      }
    } catch (e: any) {
      console.log(e);
    }
  }
});

app.provide('BACKEND_URL', backendUrl);
app.provide('APP_ENV', envName);
app.component('custom-modal', CustomModal);
app.component('custom-button', CustomButton);
app.component('custom-upload-input', CustomUploadInput);
app.component('custom-pagination', CustomPagination);
app.component('custom-phone-input', CustomPhoneInput);
app.component('custom-phone-input', CustomPhoneInput);
app.component('custom-bloc-file-input', CustomBlocFileInput);
app.component('sidebar-layout', SidebarLayout);
app.component('navbar-layout', NavbarLayout);
app.use(pinia).use(money).use(VueApexCharts).use(router).mount('#app')
